{
  "welcome": {
    "title": "Welcome to the Call Center",
    "description": "Click continue to activate sound notifications to receive alerts when a call is received.",
    "continue": "Continue"
  }
}